import { render, staticRenderFns } from "./addannouncementchannel.vue?vue&type=template&id=1b38f613&"
import script from "./addannouncementchannel.vue?vue&type=script&lang=js&"
export * from "./addannouncementchannel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b38f613')) {
      api.createRecord('1b38f613', component.options)
    } else {
      api.reload('1b38f613', component.options)
    }
    module.hot.accept("./addannouncementchannel.vue?vue&type=template&id=1b38f613&", function () {
      api.rerender('1b38f613', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmToolNew/announcement/components/addannouncementchannel.vue"
export default component.exports